import { gql } from '@apollo/client';

export default gql`
  query spaceShow {
    space {
      id
      name
      adminRole
    }
  }
`;
